import React from 'react';
import { Phone, MessageCircle, FileText } from 'lucide-react';

const MobileStickyBar = () => {
  const trackClick = (label) => {
    if (window.gtag) window.gtag('event', 'click', { event_category: 'CTA', event_label: label });
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 md:hidden bg-white/95 backdrop-blur-md border-t border-gray-200 shadow-[0_-4px_20px_rgba(0,0,0,0.1)]" style={{ zIndex: 9997 }} data-testid="mobile-sticky-bar">
      <div className="grid grid-cols-3 divide-x divide-gray-100">
        <a
          href="tel:+917757999805"
          onClick={() => trackClick('mobile_sticky_call')}
          className="flex flex-col items-center justify-center py-3 gap-1 text-[#003366] active:bg-gray-50 transition-colors"
          data-testid="mobile-cta-call"
        >
          <Phone className="w-5 h-5" />
          <span className="text-[10px] font-semibold tracking-wide">CALL NOW</span>
        </a>
        <a
          href="https://wa.me/917757999805?text=Hi%20Aquarist%20Pools%20and%20Fitness%2C%20I%20would%20like%20to%20enquire%20about%20swimming%20pool%20services."
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackClick('mobile_sticky_whatsapp')}
          className="flex flex-col items-center justify-center py-3 gap-1 text-[#25D366] active:bg-gray-50 transition-colors"
          data-testid="mobile-cta-whatsapp"
        >
          <MessageCircle className="w-5 h-5 fill-current" />
          <span className="text-[10px] font-semibold tracking-wide">WHATSAPP</span>
        </a>
        <a
          href="/booking"
          onClick={() => trackClick('mobile_sticky_quote')}
          className="flex flex-col items-center justify-center py-3 gap-1 text-[#00AEEF] active:bg-gray-50 transition-colors"
          data-testid="mobile-cta-quote"
        >
          <FileText className="w-5 h-5" />
          <span className="text-[10px] font-semibold tracking-wide">FREE QUOTE</span>
        </a>
      </div>
    </div>
  );
};

export default MobileStickyBar;
